import React, { FC, useCallback } from "react";
import {
  ArtifactV1SessionPart,
  NoteCreatedV1ArtifactPayload,
  ArtifactV1SessionPartKind,
} from "../../session.types";
import { SessionPartContext } from "../session-part.types";
import styled from "@emotion/styled";
import { MDSSessionPartContainer } from "../session-part.style";
import { NoteInfo } from "./session-artifact-note-renderer.utils";
import { DateTime } from "luxon";
import { MDSSessionArtifactNoteEmbed } from "@/mds/components/sessions/session-parts/artifacts/session-artifact-note-embed";
import { useMDSSession } from "../../context";
import { MDSSessionArtifact } from "@/mds/components/sessions/context/mds-session-context.types";

interface Props {
  part: ArtifactV1SessionPart;
  context: SessionPartContext;
}

export const MDSSessionArtifactNoteCreatedV1Part: FC<Props> = ({ part, context: _context }) => {
  const payload = part.artifact_payload as NoteCreatedV1ArtifactPayload;
  const { actions } = useMDSSession();

  const noteInfo: NoteInfo = {
    noteId: payload.note_id,
    createdAt: DateTime.fromISO(payload.note_created_at),
    updatedAt: DateTime.fromISO(payload.note_updated_at),
    encodedContent: payload.encoded_content,
    primaryLabel: payload.primary_label,
    secondaryLabel: "Created Note",
    markdownContent: payload.markdown_content,
  };

  const handleArtifactClick = useCallback(() => {
    const artifactInfo: MDSSessionArtifact = {
      kind: ArtifactV1SessionPartKind.NoteCreatedV1,
      payload,
    };

    actions.viewArtifact({ payload: artifactInfo });
  }, [actions, payload]);

  return (
    <Container>
      <MDSSessionArtifactNoteEmbed noteInfo={noteInfo} onClick={handleArtifactClick} />
    </Container>
  );
};

const Container = styled(MDSSessionPartContainer)`
  align-items: center;
  margin-top: 4px;
  margin-bottom: 16px;
`;
